<template>
  <div class="update_contact">
    <div class="update_contact__header">
      <h4 class="title">
        {{ translate('device.contacts.title') }}
      </h4>
    </div>


    <div class="content">

      <div
          class="update_contact__row"
          v-for="(contact, key) in new_contacts"
          :key="key"
      >

        <div class="type">
          <tree-select
              :options="types"
              :multiple="false"
              v-model="contact.type"
              :placeholder="contact.label"
              :clearable="false"
              :searchable="true"
              :disabled="contact.id && contact.id > 0"
          />
        </div>

        <div class="value">
          <fg-input
              v-model="contact.value"
              :placeholder="contact.label"
              :disabled="contact.id && contact.id > 0"
          />
        </div>

        <button
          v-if="contact.id"
          class="btn btn-danger btn-fill btn-wd delete"
          @click.prevent="delete_contact(key)"
        >
          <span class="mdi mdi-delete" />
        </button>

      </div>


      <div class="new_contact__block">
        <div class="new_contact" @click="add_new_contact()">
          <span class="mdi mdi-plus-box" />
          <span class="title">
            New Contact
          </span>
        </div>
      </div>

    </div>

    <div class="text-center">
      <button
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="close"
      >
        {{ translate('btn.close') }}
      </button>
      <button
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="update_contacts"
      >
        {{ translate('btn.edit') }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "AddContacts",
  props: [
    "fid",
    "types",
    "contacts"
  ],

  data () {
    return {
      new_contacts: []
    }
  },

  created() {
    this.new_contacts = JSON.parse(JSON.stringify(this.contacts));
  },

  methods: {
    update_contacts(){
      this.$http.v1.updateDeviceContact(this.fid, this.new_contacts, (response) => {
        this.new_contacts = response.data
        this.$emit("update")
      });
    },
    delete_contact(index){
      this.new_contacts.splice(index, 1)
    },
    add_new_contact(){
      this.new_contacts.push({ type: 1, value: "" })
    },
    close(){
      this.$emit("close")
    }
  },

}
</script>

<style lang="scss" scoped>
.update_contact{
  padding: 10px;
  &__header{
    .title{
      margin: 10px;
      text-align: center;
    }
  }
  .content{
    height: 400px;
    overflow-y: auto;
  }
  &__row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .type{
      flex: 1;
      margin-right: 10px;
      .vue-treeselect{
        margin-bottom: 0;
      }
    }
    .value{
      flex: 1;
      .form-group{
        margin-bottom: 0;
      }
    }
    .delete{
      width: 20px;
      min-width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .new_contact {
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 10px;
    padding: 10px;
    background: #41b8831f;
    border: 1px dashed #41b883;
    transition: 0.2s;
    margin-bottom: 20px;
    &:last-child{
      margin-right: 0;
    }
    .mdi {
      font-size: 25px;
    }
    &__block{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      background: #41b8835e;
    }
  }
}

</style>
